export const CONSENT_TYPES = ['ELECTRONIC_DELIVERY', 'TRANSACTIONAL_SMS', 'AI_CALLING'] as const;

export type ConsentTypeCode = (typeof CONSENT_TYPES)[number];

export type ConsentResponse = 'YES' | 'NO' | 'NO_RESPONSE';

export type WritableConsentResponse = Exclude<ConsentResponse, 'NO_RESPONSE'>;

export type ConsentSource = 'OLA_CLICK_THROUGH_MODAL' | 'SALESFORCE';

export type ConsentStateEntry = {
  response: ConsentResponse;
  recordedAt: string | null;
  source: string | null;
  contactAtConsent: string | null;
  requiresContactAtConsent: boolean;
};

export type ConsentState = Record<string, ConsentStateEntry>;

export type ConsentStateResponse = {
  data: {
    state: ConsentState;
  };
};

export type ConsentDecision = {
  consentType: ConsentTypeCode;
  response: WritableConsentResponse;
  contactAtConsent?: string;
};

export type SubmitConsentsBody = {
  source: ConsentSource;
  decisions: ConsentDecision[];
};

export const CONSENT_ERROR_CODES = [
  'INVALID_CONSENT_TYPE',
  'MISSING_CONTACT_AT_CONSENT',
  'IDEMPOTENCY_CONFLICT',
  'UNAUTHORIZED',
  'INTERNAL_ERROR',
] as const;

export type ConsentErrorCode = (typeof CONSENT_ERROR_CODES)[number];

export type ConsentErrorBody = {
  error: {
    code: ConsentErrorCode;
    message: string;
    details: unknown[];
  };
};
